import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Typography, Grid } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';


function DashboardDonations() {

    const karmaContext = useKarmaPoolContext();

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const [donationProofs, setDonationProofs] = useState(() => {
        return karmaContext.local.donationProofs;
    });

    useEffect(() => {
        karmaContext.donationProofManager.fetchLatestDonationProof();
    }, []);

    useEffect(() => {
        setDonationProofs(karmaContext.local.donationProofs);
    }, [karmaContext.local.donationProofs]);

    RedirectIfNotLoggedIn();

    function RenderDonationProofList() {
        if (karmaContext.local.donationProofs != null) {
            return (
                <>
                    {karmaContext.local.donationProofs.map((donationProof) => {
                        return (
                            <Box sx={{ marginBottom: "0.5rem" }}>
                                <Typography variant="body2" component="div" gutterBottom>
                                    {donationProof.donationDateTime} {""}
                                    <br />
                                    donated £{donationProof.donationAmount} to {donationProof.causeName} 
                                    <a href={"https://" + donationProof.donationURL} target="_blank" rel="noreferrer"> <strong>(receipt) </strong> </a>
                                </Typography>
                            </Box>
                        );
                    })}
                </>
            );
        }
        else {
            return (
                <>
                </>
            );
        }
    }

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <DashboardMenuHeaderComponent
                    donationsEnabled={true} />

                <Grid container spacing={1} sx={{ marginBottom: "1.0rem", marginTop: "-1rem" }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                            <strong> Donation Log </strong>
                            ({karmaContext.local.donationProofs != null ? karmaContext.local.donationProofs.length : 0} donations)
                        </Typography>
                        <Box sx={{ justifyContent: "center", alignItems: "center", marginTop: "0.75rem" }}>
                            {RenderDonationProofList()}
                        </Box>
                    </Grid>

                </Grid>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default DashboardDonations;


